import Vue from 'vue';
import Vuex from 'vuex';
import _ from 'lodash';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import initialState from './initialState';

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'aws-prod',
  state: _.cloneDeep(initialState),
  actions,
  getters,
  mutations
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js